// libs
import React from 'react';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// widgets
import ProductTable from '../ProductTable';
//style
import style from './StaleCandidateTable.module.scss';
const StaleCandidateTable = ({ staleCandidates, }) => {
    if (Array.isArray(staleCandidates) && (staleCandidates === null || staleCandidates === void 0 ? void 0 : staleCandidates.length) > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style.tableSubHeader },
                React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Med_Emphasis }, "Product with old names")),
            React.createElement(ProductTable, { productData: staleCandidates, stale: true, showHeader: false })));
    }
    return null;
};
export default StaleCandidateTable;
